/* unplugin-vue-components disabled */import { render } from "./TradingChart.vue?vue&type=template&id=19f9bb9c&scoped=true"
import script from "./TradingChart.vue?vue&type=script&lang=js"
export * from "./TradingChart.vue?vue&type=script&lang=js"

import "./TradingChart.vue?vue&type=style&index=0&id=19f9bb9c&scoped=true&lang=css"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f9bb9c"]])

export default __exports__